import { faBriefcase, faClock, faDollarSign, faLaptopHouse, faMapMarkerAlt, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, makeStyles, useMediaQuery } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import ImageGroup from "../../Components/ImageGroup";
import amazonLogo from '../../assets/brands/Amazon_logo.svg';
import axonLogo from '../../assets/brands/Axon_logo.svg';
import capitalOneLogo from '../../assets/brands/CapitalOne_logo.svg';
import squareLogo from '../../assets/brands/Square_logo.svg';
import notFound from '../../assets/not-found.jpg';
import BackButton from "./Components/BackButton";
import BulletPoints from "./Components/JobBullets";
import { useRef } from "react";
import { moveToProvidedRef } from "../../utils/helper";
import { defaultJobsPerPage } from "../../utils/Constants";
import { useCommonJobStyles } from ".";
import { forwardRef } from "react";
import { put } from "../../utils/jobsAxiosInstance";
import Meta from '../../partials/seo-meta';

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column',
            paddingTop: '2rem !important'
        },
        display: 'flex',
        justifyContent: 'space-around',
        gap: '1rem',
        '& > div:nth-child(1)': {
            flexBasis: "40%",
            minWidth: "40%",
        },
        '& > div:nth-child(2)': {
            flexBasis: "55%",
            minWidth: "55%",
        }
    },
    jobsDesc: {
        position: 'sticky',
        top: '6.5rem',
        // maxHeight: '85vh',
    },
    jobCardContainer: {
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        padding: "1rem 1.5rem 2rem 1.5rem",
        borderRadius: '10px',
        height: 'max-content',
        marginBottom: '1rem',
        '& p': {
            fontSize: "0.9rem !important",
            color: "#919191"
        }
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: "space-between",
        gap: '0.5rem',
        flexWrap: "wrap",
        '& button': {
            flexBasis: "130px"
        }
    },
    activeJob: {
        border: '1px solid blue',
    },
    actionButton: {
        textTransform: 'none',
        padding: '1rem',
        borderRadius: '8px',
        color: '#FFF',
        height: "3.5rem",
        width: '100%',
        flexBasis: "20%",
        '& span': {
            fontSize: '13px !important'
        }
    },
    comapnySiteBtn: {
        background: '#315CD5 !important',
    },
    refferButton: {
        background: '#006687 !important',
    },
    mockInterviewBtn: {
        background: '#03A576 !important',
    },
    interviewHelpBtn: {
        background: '#000000 !important',
    },
    seperatorMargin: {
        paddingTop: "2rem"
    },
    seperatorLine: {
        borderTop: '2px solid #F0F0F0',
    },
    paginationIcons: {
        display: 'flex',
        justifyContent: "end",
        '& svg': {
            width: '20px !important',
            height: '20px !important',
        }
    },
    bulletPointsContainer: {
        margin: "1rem 0",
    }
}))

const useJobStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '1rem'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    flexWrap: {
        flexWrap: 'wrap',
        gap: '1rem'
    },
    comapnyLogo: {
        width: '5rem'
    },
    jobInfo: {
        [theme.breakpoints.down("sm")]: {
            padding: "1rem 0",
            gap: '0.5rem',
        },
        display: 'flex',
        padding: '1rem 0.5rem',
        borderTop: '2px solid #F0F0F0',
        borderBottom: '2px solid #F0F0F0',
        justifyContent: 'start',
        gap: '1rem',
        overflowX: 'auto',
        '& > div': {
            minWidth: '130px',
        }
    },
    textWithIcon: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: "0.5rem"
    },
    jobDescriptionStyle: {
        marginBottom: "0.5rem",
        maxHeight: '70px',
        overflow: 'auto'
    }
}))

const JobCardContent = (props) => {
    const jobClasses = useJobStyles();
    const classes = useStyles();
    const {
        job, onGoBack
    } = props;
    const commonStyles = useCommonJobStyles()
    const isSMScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const companyLogos = {
        'axon': axonLogo,
        'Axon': axonLogo,
        'Capital One': capitalOneLogo,
        'amazon': amazonLogo,
        'Amazon': amazonLogo,
        'square': squareLogo,
        'Square': squareLogo
    };
    
    const comapnyLogo = companyLogos[job?.company] || amazonLogo;

    return (
        <>
            {props.detailedInfo && isSMScreen && onGoBack && <BackButton text={'back'} onGoBack={onGoBack} />}
            <div className={jobClasses.headerContainer}>
                <div>
                    <p>Posted: {job.jobPostingDate}</p>
                    <h3>{job.jobTitle}</h3>
                </div>
                <div>
                    <img src={comapnyLogo} className={jobClasses.comapnyLogo} />
                </div>
            </div>
            {!props.detailedInfo &&
                <div className={`${jobClasses.jobDescriptionStyle} ${commonStyles.customScroll}`}>
                    <p>{job.jobDescription}</p>
                </div>
            }
            <div className={`${jobClasses.jobInfo} ${commonStyles.customScroll}`}>
                <div>
                    <div className={jobClasses.textWithIcon}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} size="1x" />
                        <span>Location</span>
                    </div>
                    <h4>{job.jobLocation}</h4>
                </div>
                <div>
                    <div className={jobClasses.textWithIcon}>
                        <FontAwesomeIcon icon={faDollarSign} size="1x" />
                        <span>Salary</span>
                    </div>
                    <h4>${job.totalCompensation}/Year</h4>
                </div>
                {job.employmentType && props.detailedInfo && <div>
                    <div className={jobClasses.textWithIcon}>
                        <FontAwesomeIcon icon={faBriefcase} size="1x" />
                        <span>Employment Type</span>
                    </div>
                    <h4>{job.employmentType}</h4>
                </div>}
                {props.detailedInfo &&
                    <>
                        {job.experience && <div>
                            <div className={jobClasses.textWithIcon}>
                                <FontAwesomeIcon icon={faUserPlus} size="1x" />
                                <span>Experience</span>
                            </div>
                            <h4>2+ Years</h4>
                        </div>}
                    </>
                }
            </div>
            {!props.detailedInfo && job.jobApplicationCount > 0 &&
                <div className={`${classes.seperatorMargin} ${jobClasses.headerContainer} ${jobClasses.flexWrap}`}>
                    <ImageGroup images={[]} applicationCount={job.jobApplicationCount + '+'} helpText="Applicants" />
                </div>
            }
        </>
    )
}

const Jobs = (props) => {
    const classes = useStyles();
    const jobSectionRef = useRef(null);
    const jobDescRef = useRef(null);
    const jobsRef = useRef({});
    const lastAppliedJob = useRef(0);

    const commonStyles = useCommonJobStyles();
    const visibleFooterSize = props.visibleFooterSize;
    const jobs = props.jobs?.elasticJobs;
    const loading = props.loading;
    const totalCount = props.jobs?.totalCount || 0;
    const [selectedJob, setSelectedJob] = useState(0);
    const [showDesc, setShowDesc] = useState();
    const isSMScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    useEffect(() => {
        if (jobDescRef?.current?.style) {
            jobDescRef.current.style.height = `calc(85vh - ${visibleFooterSize + (visibleFooterSize != 0 ? 40 : 0)}px)`
        }
    }, [visibleFooterSize])

    useEffect(() => {
        if (showDesc === true) {
            isSMScreen && moveToProvidedRef(jobSectionRef, 100);
        } else if (showDesc === false) {
            isSMScreen && moveToProvidedRef(jobsRef.current[lastAppliedJob.current], 140);
        }
    }, [showDesc])

    const scrollDescDivToTop = () => {
        if (jobDescRef.current) {
            jobDescRef.current.scroll({
                top: 0,
                behavior: "smooth"
            });
        }
    }

    const handleRef = (index) => (node) => {
        node && (jobsRef.current[index] = { current: node });
    };

    const handleJobApply = (idx) => {
        lastAppliedJob.current = idx;
        scrollDescDivToTop();
        setShowDesc(true);
        setSelectedJob(idx);
    }

    const handleGoBack = () => {
        setShowDesc(false);
    }

    const handlePaginationChange = (val) => {
        setSelectedJob(0);
        moveToProvidedRef(jobSectionRef, 100);
        props.setCurrPage(val);
        props.getJobs(val);
    }

    return (
        <section className={classes.root} ref={jobSectionRef}>
            {((!showDesc || !isSMScreen) && jobs) && <Box flexDirection={'column'}>
                {jobs.map((job, idx) => (
                    <div
                        className={`${classes.jobCardContainer} ${selectedJob === idx ? classes.activeJob : ''}`}
                        key={idx + "JobCard"}
                        ref={handleRef(idx)}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleJobApply(idx)}
                    >
                        <JobCardContent
                            job={job}
                            onGoBack={() => handleGoBack()}
                        />
                    </div>
                ))}
                <Pagination
                    count={Math.ceil(totalCount / defaultJobsPerPage)}
                    color="primary"
                    siblingCount={1}
                    boundaryCount={1}
                    className={classes.paginationIcons}
                    onChange={(e, val) => handlePaginationChange(val)}
                    page={props.currPage}
                />
            </Box>}
            {((showDesc || !isSMScreen) && jobs) &&
                <DetailedJobViewer job={jobs[selectedJob]} onGoBack={() => handleGoBack()} ref={jobDescRef} getJobs={props.getJobs} />}
            {(!jobs || jobs.length === 0) && !loading && <div className={commonStyles.textCenter}>
                <img src={notFound} style={{ width: '5rem' }} />
                <h1>No job found</h1>
            </div>}
        </section>
    )
}

const getJobTrack = (job) => {
    if (!job || !job.jobTrack) {
        return "/mock-interview";
    }

    const jobTracks = job.jobTrack.split(", ");

    if (jobTracks.length === 0) {
        return "/mock-interview";
    }

    return `/mock-interview?track=${jobTracks[0]}`;
}

const formatText = (qualifications, company) => {
    if (company == 'amazon') {
        const qualificationsList = qualifications.split('- ');
        qualificationsList.shift();
        const formattedList = qualificationsList.map(item => `- ${item}`);
        return formattedList;
    }
    else {
        return qualifications.split();
    }

}

const formatJobPost = (post) => {
    const result = post.split(/\b\w+\.(?!\s)\w+\b/);

    // Remove any empty strings from the result
    const filteredResult = result.filter(item => item.trim() !== '');

    return filteredResult
}

export const DetailedJobViewer = forwardRef((props, ref) => {
    const jobClasses = useJobStyles();
    const classes = useStyles();
    const job = props.job;
    const commonStyles = useCommonJobStyles();
    const showInterviewHelpButton = job.isInterviewHelpExclusive ? true : false;
    const isRefferActive = false;
    const mockInterviewLink = getJobTrack(job);

    const updateJob = (job) => {
        put('/updateJob', {
            "jobId": job.objectId,
            "jobApplicationCount": job.jobApplicationCount + 1
        })
            .finally(() => {
                //props.getJobs()
            })
    }

    return (
        <div className={`${classes.jobCardContainer} ${classes.jobsDesc} ${commonStyles.customScroll}`} ref={ref}>
            <JobCardContent detailedInfo={true} job={job} onGoBack={props.onGoBack} />

            {job && <Meta
                title={(job?.jobTitle || "").substring(0, 60)}
            />}

            {job?.jobDescription && <div className={`${classes.seperatorMargin} ${classes.seperatorLine}`}>
                <h3>Job  Description</h3>
                <div className={classes.bulletPointsContainer}>
                    <p>{job.jobDescription}</p>
                </div>
            </div>}
            {job?.companyProfile && <div className={`${classes.seperatorMargin}`}>
                <h3>Company Profile</h3>
                <div className={classes.bulletPointsContainer}>
                    <p>Integer a velit ut sapien consectetur laoreet. Nulla et dui ut sem mattis tempus eget id tortor. Nunc ut tristique erat, sit amet fermentum urna. Morbi vitae sapien mattis, vene natis lacus cursus, pretium ipsum. In pellentesque tempor aliquam. Proin euismod ur na ac neque volutpat, vitae sollicitudin tortor fermentum. Maecenas tincidunt orci ut sem egestas, at sodales mi scelerisque. In iaculis a libero non accumsan.</p>
                </div>
            </div>}
            {job?.detailedJobDescription && <div className={`${classes.seperatorMargin} ${classes.seperatorLine}`}>
                <h3>Job Description</h3>
                <div className={classes.bulletPointsContainer}>
                    <p>Integer a velit ut sapien consectetur laoreet. Nulla et dui ut sem mattis tempus eget id tortor. Nunc ut tristique erat, sit amet fermentum urna. Morbi vitae sapien mattis, vene natis lacus cursus, pretium ipsum. In pellentesque tempor aliquam. Proin euismod ur na ac neque volutpat, vitae sollicitudin tortor fermentum. Maecenas tincidunt orci ut sem egestas, at sodales mi scelerisque. In iaculis a libero non accumsan.</p>
                    <BulletPoints />
                </div>
            </div>}
            {job?.jobRequirements && <div className={`${classes.seperatorMargin} ${classes.seperatorLine}`}>
                <h3>Job Requirement</h3>
                <div className={classes.bulletPointsContainer}>
                    {formatText(job.jobRequirements, job.company).map((val, idx) =>
                        <p>{val}</p>
                    )}
                </div>
            </div>}
            {job?.preferredRequirements && <div className={`${classes.seperatorMargin} ${classes.seperatorLine}`}>
                <h3>Job Preferred Requirement</h3>
                <div className={classes.bulletPointsContainer}>
                    {formatText(job.preferredRequirements, job.company).map((val, idx) =>
                        <p>{val}</p>
                    )}
                </div>
            </div>}
            {job?.jobApplicationCount > 0 &&
                <div className={`${classes.seperatorMargin} ${jobClasses.headerContainer} ${jobClasses.flexWrap}`}>
                    <ImageGroup images={[]} applicationCount={job.jobApplicationCount + '+'} helpText="Applicants" />
                </div>
            }
            <div className={`${classes.buttonContainer} ${classes.seperatorMargin}`}>
                <a href={job.jobLink} target="_blank" onClick={(e) => updateJob(job)}>
                    <Button className={`${classes.comapnySiteBtn} ${classes.actionButton}`}>
                        Apply On <br /> Company Site
                    </Button>
                </a>
                {isRefferActive ? (
                    <Button className={`${classes.refferButton} ${classes.actionButton}`}>Refferals <br /> $50</Button>
                ) : null}
                <a href={mockInterviewLink} target="_blank">
                    <Button className={`${classes.mockInterviewBtn} ${classes.actionButton}`}>Mock Interviews <br /> $250</Button>
                </a>
                {showInterviewHelpButton ? (
                    <Button className={`${classes.interviewHelpBtn} ${classes.actionButton}`}>
                        Apply On <br /> Interviewhelp.io
                    </Button>
                ) : null}
            </div>
        </div>
    )
})

export default Jobs;